export default __webpack_public_path__ + "images/play.c5019ad2a026f76af2dd082d3ad05a62.svg";